import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, startWith } from 'rxjs/operators';
import { requestActions } from './apiHelpers';
import AppState from '../reducers/app-state';
import { ReduxAction } from '@repo/utils/types';
import Contact from '@repo/utils/models/Contact';
import { apiObservable } from '@repo/utils/helpers/api';
import { selectGroup } from './groups';

/* Epic actions */
const starredActions = requestActions('STARRED', ['fetch']);

/* Component actions */
export const fetchStarred = starredActions['fetch'];

/* Selectors */
export const isStarredSelector = (contact: Contact) => (state: AppState) => {
  if (!contact) {
    return false;
  }

  const starredGroup = selectGroup('starred')(state);

  return starredGroup && starredGroup.hasContact(contact.id);
};

/* Epics */
export const fetchStarredEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('FETCH_STARRED'),
    mergeMap(() =>
      apiObservable('GET', '/network/lists/starred/', {
        query: {
          contact_ids_only: 'true',
        },
      }).pipe(
        map(starredActions['fetchSucceeded']),
        startWith(starredActions['fetchRequested']()),
        catchError((err) => of(starredActions['fetchFailed'](err))),
      ),
    ),
  );

export const starredEpic = fetchStarredEpic;
